<template>
  <v-row align="center" class="px-8 py-2 table-footer-go-to-page" no-gutters>
    <v-col cols="12" sm="6" md="3" lg="3" class="text-right mx-auto ml-lg-1">
      <v-row no-gutters>
        <v-col class="mr-3 mt-2">Go to page</v-col>
        <v-col>
          <slot name="formSlot"> </slot>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="8" sm="10" md="6" lg="5" class="ml-10 ml-md-0 ml-lg-0">
      <slot name="pageSlot"></slot>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="text-right pt-lg-4 pt-md-5 mx-auto">
      <v-row no-gutters>
        <v-col class="mr-3 mt-2"> Items per page </v-col>
        <v-col>
          <slot name="limitSlot"></slot>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: [""],
};
</script>
<style scoped lang="scss">
@media only screen and (max-width: 970px) {
  .table-footer-go-to-page {
    font-size: 0.875rem;
  }
}
</style>
